export default [
  // LANG
  { uri: "api/v1/lang/tr", name: "lang.", methods: ["POST"] },
  { uri: "api/v1/lang/{lang}", name: "lang.", methods: ["GET", "HEAD"] },
];
